<template>
  <div>
    <div class="videoWrapper">
        <div class="videoContent" @click="playVedio">
          <div class="model" v-if="modelShow">
            <img class="modelImage" :src="videoBgUrl" alt="">
          </div>
          <video v-show="!modelShow" class="video" controls="controls" preload="auto" ref="vedioRef">
            <source :src="videoUrl" type="video/mp4">
            <source :src="videoUrl" type="video/ogg">
            <source :src="videoUrl" type="video/webm">
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
  </div>
</template>

<script>

  export default {
    name: 'myVideo',
    props: ['url', 'imgUr'],
    data() {
      return {
        modelShow: true,
        videoUrl: this.url,
        videoBgUrl: this.imgUr
      }
    },
    mounted() {
      // console.log('vidoUrl', this.lastRunTime);
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      "$route": "fetchDate"
    },
    methods: {
      playVedio(event) {
        this.modelShow = false;
        let vedio;
        this.$nextTick(() => {
          vedio = this.$refs.vedioRef;
          if (!this.modelShow) {
            if (!vedio.paused) {
              vedio.pause();
            } else {
              vedio.play();
            }
          }
        })
      },
      fetchDate() {
        //    this.$nextTick(() => {
        //    const vedio = this.$refs.vedioRef;
        //    if (vedio) {
        //     vedio.load();
        //    }
        // })
      }
    }
  }
</script>

<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// src/components/myVideo.vue